export const EXAMPLE_ENDPOINT = ''
export const ONBOARDING_PAGE = 'onboarding'
export const PORTABILITY_FORM = 'request-form'
export const COMPANY_INFO = 'company'
export const REQUEST_PORTABILITY = 'request'
export const HOME_PAGE = 'home'
export const VALIDATE_PORTABILITY = 'validate'
export const BANKS_PARTICIPANTS = 'banks'
